import angular from "angular";

angular
    .module('accessControlCrud.role', [])
    .service('Role', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/roles';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.store = function (params) {
            return $http.post(uri(), params);
        };

        this.update = function (id, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(id), params);
        };

        this.delete = function (id) {
            return $http.post(uri(id), {'_method': 'DELETE'});
        };

        this.togglePermission = function (id, permissionId) {
            return $http.post(uri(id, 'toggle-permission'), {permissionId: permissionId});
        };

    }]);

export default 'accessControlCrud.role';


// WEBPACK FOOTER //
// ./resources/assets/modules/access-control-crud/role.js